import { Component, Input, OnInit } from '@angular/core';

import { NavbarItem, ICONS } from './NavbarItem';

import { environment } from '~environment';

const REALPAGE_LOGO = `${environment.staticFiles}/images/rp-logo-2tone.svg`;

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  @Input() linkHref: string;

  rpLogo = REALPAGE_LOGO;

  private items: NavbarItem[] = [
    { icon: ICONS.GRID },
    { icon: ICONS.HELP },
    { icon: ICONS.COG },
    { icon: ICONS.BELL },
    { icon: ICONS.USER }
  ];

  constructor() { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/navbar.component.ts